import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_SENSOR_DATA_URL } from '../../core.global';
import { BasicService } from '../../_base/services/basic.service';

export type SensorHealthStatus = 'good' | 'warning' | 'bad' | 'unavailable';

export interface SensorTypeData {
    id: number;
    name: string;
    tech_type?: string | null;
    identificator?: string | null;
    description?: string | null;
    code?: string | null;
    unit?: string | null;
    value_type?: string | null;
    min_value?: number | null;
    max_value?: number | null;
    health_enabled?: boolean;
    health_bad_min?: number | null;
    health_bad_max?: number | null;
    health_warning_min?: number | null;
    health_warning_max?: number | null;
    health_good_min?: number | null;
    health_good_max?: number | null;
}

export interface CurrentSensorData {
    device_id: number;
    sensor_id: number;
    sensor_type_id: number;
    value: number | null;
    create_date: string;
    health_status: SensorHealthStatus;
    SensorType: SensorTypeData;
}

export interface HistoricalSensorData {
    id: number;
    create_uid?: number;
    device_id: number;
    sensor_type_id: number;
    value: number | null;
    create_date: string;
    Device?: { id: number; location_id?: number | null };
    SensorType: SensorTypeData;
}

export interface SensorDataResponse<T> {
    message: string;
    itemList: T[];
}

@Injectable()
export class SensorDataService extends BasicService{
    baseUrl:string = '';
    
    constructor(protected http: HttpClient){
        super(http);
        this.baseUrl = API_SENSOR_DATA_URL;
    }

    instant(filter){
        let queryParams =  new HttpParams();
        Object.keys(filter).forEach((field)=>{
            queryParams = queryParams.append(field, filter[field]);
        })
        return this.http.get(`${this.baseUrl}/instant`, {params: queryParams})
    }

    period(filter){
        let queryParams =  new HttpParams();
        Object.keys(filter).forEach((field)=>{
            queryParams = queryParams.append(field, filter[field]);
        })
        return this.http.get(`${this.baseUrl}/period`, {params: queryParams})
    }

    getCurrentSensorData(filters: {
        deviceId?: number;
        locationId?: number;
        sensorTypeId?: number;
    }) {
        let params = new HttpParams();
        if (filters.deviceId) params = params.set('device_id', `${filters.deviceId}`);
        if (filters.locationId) params = params.set('location_id', `${filters.locationId}`);
        if (filters.sensorTypeId) params = params.set('sensor_type_id', `${filters.sensorTypeId}`);

        return this.http.get<SensorDataResponse<CurrentSensorData>>(
            `${this.baseUrl}/instant/current`, { params }
        );
    }

    getSensorHistory(deviceId: number, sensorTypeId: number, startDate: Date, endDate: Date) {
        const params = new HttpParams()
            .set('device_id', `${deviceId}`)
            .set('sensor_type_id', `${sensorTypeId}`)
            .set('st', startDate.toISOString())
            .set('et', endDate.toISOString());

        return this.http.get<SensorDataResponse<HistoricalSensorData>>(
            `${this.baseUrl}/period/validated`, { params }
        );
    }
}
